export default "__VITE_ASSET__BWL4gPEH__"